var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FatorRisco',{attrs:{"form":_vm.form,"model":_vm.model}}),_c('Alergia',{attrs:{"data":{ form: _vm.form, model: _vm.model },"hide-info":""}}),_c('MedicamentoUsoContinuo',{attrs:{"data":{ form: _vm.form, model: _vm.model },"hide-info":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }